import { jwtDecode } from "jwt-decode";

export interface JwtPayload {
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role": string;
  exp: number;
}

export const getUserRole = (): string | null => {

  const token = localStorage.getItem("token");

  if (!token) return null;

  try {

    const decoded = jwtDecode<JwtPayload>(token);

    return decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

  } catch {
    return null;
  }
};